import * as t from 'io-ts'

import fetchApi from "ui-io/fetch-api";
import { NoteToAddT, ReferenceT, TodoNoteT } from '../../task-io'

export type ComplexAddBody = {
  notes: NoteToAddT[]
  references: ReferenceT[]
}

const TaskComplexAddResultIO = t.type({
  task_id: t.string,
  note_id: t.string,
})

export const taskComplexAddMutation = ({
  taskId,
  companyID,
  body,
}: {
  taskId: string
  companyID: string
  body: TodoNoteT
}) =>
  fetchApi({
    service: 'admin-service',
    method: 'POST',
    pathname: `/tasks/${taskId}/${companyID}/_add`,
    body: body,
    codec: TaskComplexAddResultIO,
  })
